import type { CrmListObjectType } from "../../crm-integration/types/object-type";
import type { CrmIntegrationProvider } from "../../crm-integration/types/provider";

export enum ListVariant {
    Static = "Static",
    Crm = "Crm",
}

export type StaticListId = string;

export type CrmListId = `${CrmIntegrationProvider}-${CrmListObjectType}`;

export type StaticListParams = {
    variant: ListVariant.Static;
    id: StaticListId;
};

export type CrmListParams = {
    variant: ListVariant.Crm;
    id: CrmListId;
};

export type ListParams = StaticListParams | CrmListParams;
